import { useEffect } from 'react';

import { useApolloClient } from '@apollo/client/react';

export function useSidebarRevalidator(): void {
  const client = useApolloClient();

  useEffect(() => {
    const onSubmitEnd = async (event: DocumentEventMap['echo:submit-end']) => {
      const isMutation = event.detail.method !== 'GET';
      const isSuccess = event.detail.status && event.detail.status <= 299;

      if (isMutation && isSuccess) {
        await client.refetchQueries({
          updateCache(cache) {
            cache.evict({ fieldName: 'envelopes' });
          },
        });
      }
    };

    document.addEventListener('echo:submit-end', onSubmitEnd);
    return () => document.removeEventListener('echo:submit-end', onSubmitEnd);
  }, [client]);
}
